/**
 * @generated SignedSource<<6047fb5438b5dd36d55fe88c65502282>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentSkillAssessmentDailySnapshotFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  reportDate: any;
  siteIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardGetDailySnapshotQuery$variables = {
  filter: StudentSkillAssessmentDailySnapshotFilterInput;
};
export type DashboardGetDailySnapshotQuery$data = {
  readonly studentsSkillAssessmentsDailySnapshot: ReadonlyArray<{
    readonly numberOfStudents: number;
    readonly score: number | null | undefined;
  }>;
};
export type DashboardGetDailySnapshotQuery = {
  response: DashboardGetDailySnapshotQuery$data;
  variables: DashboardGetDailySnapshotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentsSkillAssessmentsDailySnapshotReport",
    "kind": "LinkedField",
    "name": "studentsSkillAssessmentsDailySnapshot",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfStudents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "score",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardGetDailySnapshotQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardGetDailySnapshotQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2cb82fd524f8307cfcfc922c538bda66",
    "id": null,
    "metadata": {},
    "name": "DashboardGetDailySnapshotQuery",
    "operationKind": "query",
    "text": "query DashboardGetDailySnapshotQuery(\n  $filter: StudentSkillAssessmentDailySnapshotFilterInput!\n) {\n  studentsSkillAssessmentsDailySnapshot(filter: $filter) {\n    numberOfStudents\n    score\n  }\n}\n"
  }
};
})();

(node as any).hash = "fab07603c1f3dcc44669f6894cd835a7";

export default node;
